import { create } from 'zustand';

interface AtsNavigationState {
  selectedFolder: string;
  refreshVersion: number;
  folderSearchResetVersion: number;
  isAtsSidebarExpanded: boolean;
  setSelectedFolder: (folder: string, resetSearch?: boolean) => void;
  toggleAtsSidebarExpanded: () => void;
  notifyCandidatesUpdated: () => void;
}

export const useAtsNavigationStore = create<AtsNavigationState>((set) => ({
  selectedFolder: '',
  refreshVersion: 0,
  folderSearchResetVersion: 0,
  isAtsSidebarExpanded: false,
  setSelectedFolder: (folder, resetSearch = false) => set((state) => ({
    selectedFolder: folder,
    ...(resetSearch ? { folderSearchResetVersion: state.folderSearchResetVersion + 1 } : {}),
  })),
  toggleAtsSidebarExpanded: () => set((state) => ({
    isAtsSidebarExpanded: !state.isAtsSidebarExpanded,
  })),
  notifyCandidatesUpdated: () => set((state) => ({ refreshVersion: state.refreshVersion + 1 })),
}));
